import {getData} from "../api/get-data";

export const setPriceInc = (itemId, resolveHandler) => {
  getData({
    [`set_price`]: {
      [`item_id`]: itemId,
      [`action`]: `inc`,
    }
  })
  .then((response) => {
    resolveHandler(response);
  });
};
